import { useQuery } from '@tanstack/react-query'
import { fetchPartnerCategories } from 'utility/queries/partner'

export const usePartnerCategories = () =>
	useQuery({
		queryKey: ['partnerCategories'],
		queryFn: () => fetchPartnerCategories(),
	})
